import type { TenantConfig } from '@/types/TenantConfig'

const yellow = '#FBD220'
const orange = '#F6B11A'
const midGrey = '#383839'
const teal = '#50BBAB'

export const electricplayhouse: TenantConfig = {
  logo: 'assets/electricplayhouse/static/logo.png',
  themeOptions: {
    primaryColor: teal,
    secondaryColor: yellow,
    footerBackgroundColor: midGrey,
    footerTextColor: 'white',
    logoHeight: '90px',
    headerBackground: 'black',
    headerHeight: '120px',
    cartHeaderBackgroundColor: 'black',
    memberLinksColor: yellow,
    memberLinksColorHover: orange,
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/electricplayhouse/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
